import { VITE_POSTHOG_PROJECT_API_KEY } from "@/modules/global-state/globalEnv";

export const clientEnvPosthogProjectApiKey = (): string | undefined => {
  return VITE_POSTHOG_PROJECT_API_KEY || undefined;
};
